export default __webpack_public_path__ + "static/media/22.3f4d5160.png";